import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const EmailSettingsPanel = () => {
  const { data } = useQuery({ queryKey: ["admin-email-settings"], queryFn: () => api.get("/admin/email-settings").then((r) => r.data) });
  const [form, setForm] = useState({ reply_to: "", mailing_address: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (data) setForm({ reply_to: data.reply_to || "", mailing_address: data.mailing_address || "" }); }, [data]);
  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/email-settings", { reply_to: form.reply_to || null, mailing_address: form.mailing_address }); toast.success("Email settings saved"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="rounded-md border border-[#2D3442] bg-[#0F131A] p-6" data-testid="admin-email-settings">
      <div className="lf-label">Email settings</div>
      <p className="mt-2 text-xs text-[#A8A090]">Replies to your emails go to the reply-to address. Anti-spam laws (like CAN-SPAM) require a postal address in promotional emails; it's shown in each announcement's footer.</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        <label className="text-xs text-[#A8A090]">Reply-to email<Input type="email" value={form.reply_to} onChange={(e) => setForm({ ...form, reply_to: e.target.value })} placeholder="hello@yourdomain.com" className="mt-1" data-testid="email-reply-to" /></label>
        <label className="text-xs text-[#A8A090]">Mailing address<Input value={form.mailing_address} onChange={(e) => setForm({ ...form, mailing_address: e.target.value })} placeholder="PO Box 123, City, State ZIP, Country" className="mt-1" data-testid="email-mailing-address" /></label>
      </div>
      <div className="mt-3 flex justify-end"><Button variant="outline" onClick={save} disabled={busy} data-testid="email-settings-save">Save</Button></div>
    </section>
  );
};
